export default "__VITE_ASSET__BQdgET8Q__"